import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Server,
  Globe,
  BarChart3,
  ShoppingCart,
  Smartphone,
  Users,
  ScanLine,
  Monitor,
  Settings,
  ArrowRight,
} from 'lucide-react';
import Button from '../../components/Button';
import LogoCNA from '../../ressources/images/Logo_cna.jpg';

const DOMAINES = [
  { key: 'expmetier_dom1', icon: Server },
  { key: 'expmetier_dom2', icon: Globe },
  { key: 'expmetier_dom3', icon: BarChart3 },
  { key: 'expmetier_dom4', icon: ShoppingCart },
  { key: 'expmetier_dom5', icon: Smartphone },
  { key: 'expmetier_dom6', icon: Users },
  { key: 'expmetier_dom7', icon: ScanLine },
  { key: 'expmetier_dom8', icon: Monitor },
  { key: 'expmetier_dom9', icon: Settings },
];

export default function PlateformeBillettique() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('expmetier_billettique_title')}</title>
      </Helmet>

      <div className="wrapper mt-32 mb-24 md:mt-44">

        {/* En-tete */}
        <h1 className="text-4xl font-bold text-center text-gray-800 md:text-5xl" data-aos="zoom-in">
          {t('expmetier_billettique_h1')}
          <span className="text-primOrange"> {t('expmetier_billettique_h1_accent')}</span>
        </h1>

        <p className="text-center mt-6">
          <span className="inline-block px-5 py-1 font-bold border-2 rounded-full border-primOrange text-primOrange font-roboto">
            {t('expmetier_billettique_depuis')}
          </span>
        </p>

        <p className="max-w-3xl mx-auto mt-8 text-center paragraph">
          {t('expmetier_billettique_intro')}
        </p>

        {/* Perimetre : les 9 briques du systeme billettique */}
        <h2 className="mt-24 text-center second-title">
          {t('expmetier_perimetre_titre')}
          <span className="text-primOrange"> {t('expmetier_perimetre_titre_accent')}</span>
        </h2>

        <p className="max-w-3xl mx-auto text-center paragraph">
          {t('expmetier_perimetre_intro')}
        </p>

        <div className="grid grid-cols-1 gap-6 mt-12 sm:grid-cols-2 lg:grid-cols-3" data-aos="fade-up">
          {DOMAINES.map(({ key, icon: Icon }) => (
            <div key={key} className="flex items-center gap-4 p-6 bg-white rounded-xl job-shadow">
              <span className="flex items-center justify-center rounded-full shrink-0 w-14 h-14 bg-orange-50">
                <Icon size={26} color="#FF9703" />
              </span>
              <p className="font-medium text-gray-800 font-roboto">{t(key)}</p>
            </div>
          ))}
        </div>

        {/* Adherents Calypso Networks Association */}
        <div className="mt-24 overflow-hidden bg-white rounded-xl job-shadow" data-aos="fade-up">
          <div className="grid items-center gap-8 p-8 md:grid-cols-2 md:p-12">
            <div>
              <h2 className="second-title">
                {t('expmetier_cna_titre')}
                <span className="text-primOrange"> {t('eco_cna')}</span>
              </h2>
              <p className="paragraph">{t('eco_cna_text')}</p>
              <a
                href="https://calypsonet.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-6 font-bold text-primOrange"
              >
                {t('expmetier_cna_lien')}
                <ArrowRight size={18} />
              </a>
            </div>
            <div className="flex items-center justify-center">
              <a href="https://calypsonet.org/" target="_blank" rel="noopener noreferrer">
                <img
                  src={LogoCNA}
                  alt="Calypso Networks Association"
                  className="w-full max-w-[360px] mx-auto"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Equipe */}
        <div className="mt-24 text-center" data-aos="fade-up">
          <h2 className="second-title">
            {t('expmetier_equipe_titre')}
            <span className="text-primOrange"> {t('expmetier_equipe_titre_accent')}</span>
          </h2>
          <p className="max-w-3xl mx-auto text-center paragraph">
            {t('expmetier_equipe_texte')}
          </p>
          <Link
            to="/qui-sommes-nous"
            className="inline-flex items-center gap-2 mt-6 font-bold text-primOrange"
          >
            {t('expmetier_equipe_lien')}
            <ArrowRight size={18} />
          </Link>
        </div>

        {/* Contact */}
        <div className="flex justify-center mt-16">
          <Button to="/contact" texte={t('projet_cta')} />
        </div>

      </div>
    </>
  );
}
